import React, { useState } from 'react';
import { AGridColDef } from '../../../../../../views/pages/manage/common/data-grid/ADataGridColDef';
import ADataGrid from '../../../../../../views/pages/manage/common/data-grid/ADataGrid';
import { gridComponents, gridStyles } from '../../../../../../views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant';
import MultiSelectCellComponentWithSearch from '../../../../../../views/pages/manage/common/commonComponents/SearchFilterView/MultiSelectCellComponentWithSearch';
import { ReactComponent as EyeIcon } from "assets/img/svg/eye.svg";
import ViewReceiptDetailsDialog from './ViewReceiptDetailsDialog';
import { dataGridRoundCheckBoxes } from '../../../../refundMasters/refundCompletionMaster/ListComponent';
import EnhanceDataGrid from '../../../../../../views/pages/manage/common/data-grid/EnhanceDataGrid';
import { formattedPrice } from '../../../../../../views/pages/manage/unAssigned/collectPayment/utils';
import styles from "../../styles.module.scss";
import { CourseDetailsPopupById } from '../../../../../../views/pages/manage/unAssigned/studentCharges/common';
import { useWizard } from '../../../../../../components/wizard/WizardContext';


const ReceiptsList = ({
  receiptsData,
  selectionModel,
  setSelectionModel,
  checkboxSelection = true,
}) => {
  
  const [viewReceiptDetailsDialogInfo, setViewReceiptDetailsDialogInfo] = useState({});
  const {values} = useWizard();
  const { courseId } = values?.selectedStudent ?? {};

  const columns = [
    new AGridColDef("paymode", "Paymode", false)
      .setMinWidth(80)
      .setFlex(0.8)
      .editable(true)
      .setValueGetter((params) => params?.value),

    new AGridColDef("receiptId", "Receipt number", false)
      .setMinWidth(120)
      .setFlex(0.8)
      .editable(true)
      .setValueGetter((params) => params?.value),

    new AGridColDef("referenceNumber", "Reference number", false)
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(true)
      .setValueGetter((params) => params?.value),

    new AGridColDef("receiptDate", "Receipt date & time", false)
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(true)
      .setValueGetter((params) => params?.value),

    new AGridColDef("courseId", "Course Id", false)
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(true)
      .renderCellComponent(params => {
        const value = params?.row?.isMiscCharge ? params?.value : courseId;
        return (
          <>
            <div className="ellipsis-text-container">{value}</div>
            <CourseDetailsPopupById courseId={value} placement="left-end" cta={<EyeIcon className='ml-2' />} />
          </>
        )
      }
      ),

    new AGridColDef("itemTypeList", "Desc", false)
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(true)
      .renderCellComponent(params =>
        <MultiSelectCellComponentWithSearch title={"Item Types"} data={params?.value} />
      ),

    new AGridColDef("createdBy", "Created By", false)
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(true)
      .setValueGetter((params) => params?.value),

    new AGridColDef("totalReceiptedAmount", "Total Receipt Amount", false)
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(true)
      .setValueGetter((params) => formattedPrice(params?.value)),

    new AGridColDef("paymodeAmount", "Paymode Amount", false)
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(true)
      .renderCellComponent((params) => <div className={styles['amount']}>{formattedPrice(params?.value)}</div>),

    new AGridColDef("action", "Action", false)
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(true)
      .renderCellComponent(params => {
        return (
          <EyeIcon className='cursor' onClick={() => setViewReceiptDetailsDialogInfo({ isOpen: true, receiptId: params?.row?.receiptId })} />
        )
      })
  ]

  return (
    <>
      <EnhanceDataGrid
        removeWrapperContainer
        rows={receiptsData}
        columns={columns}
        rowId={(row) => row?.key}
        rowHeight={50}
        loading={false}
        // components={{
        //   ...gridComponents,
        //   ...dataGridRoundCheckBoxes
        // }}
        sx={gridStyles}
        hidePagination
        checkboxSelection={checkboxSelection}
        selectionModel={selectionModel}
        disableSelectionOnClick
        disableMultipleRowSelection
        hideFooterSelectedRowCount
        onSelectionModelChange={(newSelectionModel) => {
          const modelLength = newSelectionModel?.length
          const updatedSelectionModel = modelLength > 1 ? [newSelectionModel[modelLength - 1]] : newSelectionModel;
          setSelectionModel(updatedSelectionModel);
        }}
        checkbox={dataGridRoundCheckBoxes}
      />

      <ViewReceiptDetailsDialog
        dialogInfo={viewReceiptDetailsDialogInfo}
        setDialogInfo={setViewReceiptDetailsDialogInfo}
      />
    </>

  );
}

export default ReceiptsList;